module.exports = __webpack_public_path__ + "static/media/icon-nest.1968dfba.svg";